

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Box, Grid, KeyValue, SectionHeader } from 'web-library';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme) =>
({
  container: {
    paddingBottom: theme.spacing(1),
  },
}));

export interface ExamDetailProps {
  examSeries: string;
  examLevel: string;
  year: number;
  school: string;
}

const ExamDetail = ({ examSeries, examLevel, year, school }: ExamDetailProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <SectionHeader title={t('components->>ExamDetail.Exam Details')} />
      <Grid container>
        <Grid md={6} xs={12}>
          <KeyValue
            keyText={t('components->>ExamDetail.Exam Series')}
            valueText={t('components->>{{examSeries}}', { examSeries })}
          />
        </Grid>
        <Grid md={6} xs={12}>
          <KeyValue
            keyText={t('components->>ExamDetail.Exam Level')}
            valueText={t('components->>{{examLevel}}', { examLevel })}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid md={6} xs={12}>
          <KeyValue keyText={t('components->>ExamDetail.ExamYear')} valueText={year.toString()} />
        </Grid>
        <Grid md={6} xs={12}>
          <KeyValue keyText={t('components->>ExamDetail.Exam Centre/School')} valueText={school} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ExamDetail;
